export default "__VITE_ASSET__CHHdMee4__"